import { render, staticRenderFns } from "./AlphabetDictationCreate.vue?vue&type=template&id=bb770b64&scoped=true&"
import script from "./AlphabetDictationCreate.vue?vue&type=script&lang=js&"
export * from "./AlphabetDictationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb770b64",
  null
  
)

export default component.exports